const CARDS_PER_LOAD = 8;

document.addEventListener('DOMContentLoaded', () => {
  const initLoadMoreButtonForMdOrWider = () => {
    const loadMoreBtn = document.getElementById('loadMoreBtn');
    const loadBtnContainer = document.getElementById('loadBtnContainer');
    const allHiddenCardsOnLoad = document.querySelectorAll('.extra-cards');
    let currentIndex = 0;

    loadMoreBtn.addEventListener('click', () => {
      let revealedCardsCount = 0;

      // On Load More button click, reveal the 8 following cards one by one
      while (
        revealedCardsCount < CARDS_PER_LOAD &&
        currentIndex < allHiddenCardsOnLoad.length
      ) {
        const item = allHiddenCardsOnLoad[currentIndex];
        item.classList.remove('d-md-none');
        currentIndex++;
        revealedCardsCount++;
      }

      if (currentIndex >= allHiddenCardsOnLoad.length) {
        loadBtnContainer.style.display = 'none';
      }
    });
  };

  initLoadMoreButtonForMdOrWider();
});
